<div class="psw-change-container">
  <div class="cross-back pointer" (click)="closeModalPasswordChange()">
    <mat-icon svgIcon="crossMenu"></mat-icon>
  </div>
  <div class="resetpassword-content">
    <div class="resetpassword-container">
      <div class="resetpassword-form alt-flex-column-start">
        <p class="text-singup alt-inter-bold alt-size-20 ">{{"AUTH.new-password" | translate}}</p>
        <p class="secondary-text  alt-inter-medium alt-size-16">{{"AUTH.confirm-text" | translate}}</p>

        <form [formGroup]="currentPassword" class="validPassword input-format"
          [class.statusFailed]="statusDetail == 'error'">
          <mat-form-field class="form-field margin-field2" appearance="outline">
            <mat-label class="alt-inter-medium alt-size-16">{{"AUTH.actualPassword" | translate}}</mat-label>

            <input #first matInput [type]="hide ? 'password' : 'text'" formControlName="currentPasword"
              (change)="gettingValue(first.value)">

            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon class="hide-psw-icon pointer">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>

            <mat-error *ngIf="newPasswordInvalid"></mat-error>
            <mat-error *ngIf="newPasswordInvalid2"></mat-error>
            <p class="invalid-actual-password alt-size-10 alt-inter-regular" *ngIf="statusDetail == 'error'"
              [class.alt-color-system]="statusDetail == 'error'">{{"AUTH.notCurrentPassword" | translate }}</p>
          </mat-form-field>
        </form>

        <form autocomplete="off" [formGroup]="newPasswordValidations"
          class="resetpassword-form alt-flex-column-start input-format">

          <mat-form-field [hideRequiredMarker]=" hideRequiredControl.value" class="form-field margin-field2"
            appearance="outline">

            <mat-label class="alt-inter-medium alt-size-16">{{"AUTH.new-password" | translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="newPassword"
              [disabled]="isCurrentPassword === false">
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon class="hide-psw-icon pointer">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>

            <mat-error *ngIf="newPasswordInvalid"></mat-error>
            <mat-error *ngIf="newPasswordInvalid2"></mat-error>
          </mat-form-field>

          <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-field margin-field2"
            appearance="outline">
            <mat-label class="alt-inter-medium alt-size-16">{{"AUTH.confirm-password-field" |
              translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="confirmPassword"
              [disabled]="isCurrentPassword === false">
            <mat-error *ngIf="confirmPasswordInvalid">{{"AUTH.pswModalinvalid" | translate}}</mat-error>
          </mat-form-field>

          <div>
            <p class="validations alt-row-align-center alt-inter-regular  alt-size-12" *ngFor="let validation of rules">
              <mat-icon class="cheked" [svgIcon]="validation.value ? 'doneCheck' : 'undoneCheck'"></mat-icon>
              {{validation.rule | translate}}
            </p>
          </div>

          <button *ngIf="statusDetail == 'success'" [disabled]="newPasswordValidations.invalid" [class.btn-disabled]="newPasswordValidations.invalid" [class.curretValid]="statusDetail == 'success'"
             type="button"
            class="submit-btn alt-size-14 alt-inter-semibold pointer" mat-button
            (click)="sendNewCredencial(newPasswordValidations.value)">{{"AUTH.restore" |
            translate}}</button>
        </form>

      </div>
    </div>
  </div>
</div>
